import { render, staticRenderFns } from "./EventSeatingCharts.vue?vue&type=template&id=972aaf62"
import script from "./EventSeatingCharts.vue?vue&type=script&lang=js"
export * from "./EventSeatingCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports